var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "button button--icon",
      class: _vm.buttonClass,
      attrs: {
        disabled: _vm.isDisabled,
        href: _vm.href,
        title: _vm.label,
        target: _vm.target,
      },
    },
    [
      _vm.icon
        ? _c("icon", {
            attrs: { name: _vm.icon, height: _vm.height, width: _vm.width },
          })
        : _vm._e(),
      _c("span", { staticClass: "u-sr-only" }, [_vm._v(_vm._s(_vm.label))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }